import { render } from "./ProduitColisPostaux.vue?vue&type=template&id=9fe6d1fa&scoped=true&ts=true"
import script from "./ProduitColisPostaux.vue?vue&type=script&lang=ts"
export * from "./ProduitColisPostaux.vue?vue&type=script&lang=ts"

import "./ProduitColisPostaux.vue?vue&type=style&index=0&id=9fe6d1fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe6d1fa"]])

export default __exports__